export const TIPO_PORCENTAGEM = 1
export const TIPO_VALOR_FIXO = 2

export const Tipos = {
  [TIPO_PORCENTAGEM]: {title: 'Porcentagem', class: ''},
  [TIPO_VALOR_FIXO]: {title: 'Valor fixo', class: ''},
}
